import { ssFetchJSON } from '../modules/ssFetch';
import { IProMembershipProgram } from './Providers/Plan';

import { ApiCache } from './Providers/Providers';

export const getProMembershipPrograms = async (): Promise<Array<IProMembershipProgram>> => {
  const url = '/api/v2/promembershipprograms';
  return ssFetchJSON<Array<IProMembershipProgram>>(url, { ssCache: ApiCache });
};
